import {
    showErrorNotification,
    showSuccessNotification
} from "../../../../components/ServiceNotifications.tsx";
import {
    fetchUserAttributes,
    updateUserAttribute,
    type UpdateUserAttributeOutput
} from "aws-amplify/auth";
import {UserProfileAttribute} from "../types.ts";

const attributesMap = {
    givenName: 'given_name',
    familyName: 'family_name',
    middleName: 'middle_name',
    name: 'name',
    email: 'email',
    birthdate: 'birthdate',
    zoneInfo: 'zoneinfo',
    locale: 'locale',
    website: 'website',
    picture: 'picture',
    address: 'address',
    phoneNumber: 'phone_number',
    gender: 'gender',
    profile: 'profile',
    nickname: 'nickname',
    // FNP-2261: custom:account_id and custom:account_admin are read-only here.
    // The portal client may not write them (FNP-2258), so they are not mapped.
    // sub: 'sub',
    // identities: 'identities',
    // emailVerified: 'email_verified'
} as { [key: string]: string }

const reverseAttributesMap = {
    sub: 'sub',
    identities: 'identities',
    given_name: 'givenName',
    family_name: 'familyName',
    middle_name: 'middleName',
    name: 'name',
    email: 'email',
    email_verified: 'emailVerified',
    birthdate: 'birthdate',
    zoneinfo: 'zoneInfo',
    locale: 'locale',
    website: 'website',
    picture: 'picture',
    address: 'address',
    phone_number: 'phoneNumber',
    gender: 'gender',
    profile: 'profile',
    nickname: 'nickname',
    'custom:account_admin': 'accountAdmin',
    'custom:account_id': 'accountId'
} as { [key: string]: string }


export const fetchRecords = async () => {

    const output = await fetchUserAttributes()

    const records = [] as UserProfileAttribute[]
    Object.keys(output)
          .forEach((key: string) => {
              const normalizedKey = reverseAttributesMap[key]
              records.push({
                               name: normalizedKey,
                               value: output[key] as string
                           } as UserProfileAttribute)
          })

    return records
};

export const fetch = async (id: string) => {
    const all = await fetchRecords()
    return all.find(item => item.name === id)
}

export const add = async (values: UserProfileAttribute) => {
    showSuccessNotification('User attribute added')
    return values;
}

export const update = async (id: string, record: UserProfileAttribute) => {
    console.debug('Updating user attribute', id, record)

    const attributeKey = attributesMap[record.name as string]
    if (attributeKey) {
        await handleUpdateUserProfileAttribute(attributeKey, record.value as string)
    }

    return record;
};

const handleUpdateUserProfileAttribute = async (attributeKey: string, value: string) => {
    try {
        const output = await updateUserAttribute({
                                                     userAttribute: {
                                                         attributeKey,
                                                         value
                                                     }
                                                 });
        handleUpdateUserProfileAttributeNextSteps(output);
    } catch (error) {
        const reason = error instanceof Error ? error.message : String(error)
        showErrorNotification(`Could not update ${attributeKey}: ${reason}`)
    }
}

const handleUpdateUserProfileAttributeNextSteps = (output: UpdateUserAttributeOutput) => {
    const {nextStep} = output;

    let codeDeliveryDetails;

    switch (nextStep.updateAttributeStep) {
        case 'CONFIRM_ATTRIBUTE_WITH_CODE':
            codeDeliveryDetails = nextStep.codeDeliveryDetails;
            showSuccessNotification(`Message sent using ${codeDeliveryDetails?.deliveryMedium} to ${codeDeliveryDetails?.destination}`)
            console.log(
                `Confirmation code was sent to ${codeDeliveryDetails?.deliveryMedium}.`
            );
            // Collect the confirmation code from the user and pass to confirmUserProfileAttribute.
            break;
        case 'DONE':
            console.log(`attribute was successfully updated.`);
            break;
    }
}

export const deleteRecord = async (id: string) => {
    showSuccessNotification(`profile attribute deleted ${id}`)
}

